export default "__VITE_ASSET__DDp7BWjD__"